import {useState} from 'react';

const useHighlightsState = () => {
    const [isFullscreen, setIsFullscreen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);

    return {
        isFullscreen,
        setIsFullscreen,
        currentIndex,
        setCurrentIndex,
    };
};

export default useHighlightsState;
